












import {Route} from 'vue-router';
import {Component, Vue} from 'vue-property-decorator';
import ChatHeader from '@/components/headers/ChatHeader.vue';
import Maintenance from '@/components/maintenace/Maintenance.vue';
import ChatResetConv from '@/components/resetConv/ChatResetConv.vue';
import Timeline from '@/components/timeline/Timeline.vue';
import MoreMessageBox from '@/components/timeline/MoreMessageBox.vue';
import ChatActionForm from '@/components/forms/ChatActionForm.vue';
import {AsixModule} from '@/store/modules/asix';
import {AppModule} from '@/store/modules/app';
import {isSmartPhone} from '@/util/index';

@Component({
  components: {
    ChatHeader,
    Maintenance,
    ChatResetConv,
    Timeline,
    MoreMessageBox,
    ChatActionForm,
  },
})
export default class Chat extends Vue {
  public appStore = AppModule
  public asixStore = AsixModule

  get isMaintenance(): boolean {
    return this.appStore.isMaintenance
  }

  public async mounted() {
    try {
      if (isSmartPhone()) {
        parent.postMessage('view_smp', '*');
      } else {
        parent.postMessage('view_pc', '*');
      }
      if (this.appStore.errCode) {
        this.appStore.clearErrCode()
        await this.asixStore.post(this.appStore.errCode)
      } else {
        await this.asixStore.welcomePost()
      }
    } catch (e) {
      this.appStore.setIsMaintenance(true)
    }
  }

  public async minimize(params: any): Promise<Route> {
    parent.postMessage('window_minimize', '*');
    return this.$router.push({name: 'Top', params});
  }

  public async resetConv(params: any): Promise<Route> {
    parent.postMessage('reset_conversation', '*');
    return this.$router.push({name: 'Chat', params});
  }
}
